import { t, translate } from "../I18n";
export const PProductError = {
    unavailable(parameters) {
        return new Unavailable(parameters);
    },
    temporarilyUnavailable() {
        return new TemporarilyUnavailable();
    },
    notDivisible(details) {
        return new NotDivisible(details);
    },
    outOfOrderingHours(nextOrderAvailableAt, canPreorder) {
        return new OutOfOrderingHours(nextOrderAvailableAt, canPreorder);
    },
    productCartOfOrderingHours(nextOrderAvailableAt, canPreorder) {
        return new ProductCartOutOfOrderingHours(nextOrderAvailableAt, canPreorder);
    },
};
class Unavailable {
    constructor(parameters) {
        this.type = "Unavailable";
        this.level = "warning";
        if (parameters.length === 0) {
            this.message = translate(t._core_types_sites.menu.creator.errors.productUnavailableInThisVariant);
        }
        else if (parameters.length === 1) {
            this.message = `${translate(t._core_types_sites.menu.creator.errors
                .productUnavailableInThisVariantOneParameter)}: ${parameters.join(", ")}.`;
        }
        else {
            this.message = `${translate(t._core_types_sites.menu.creator.errors.productUnavailableInThisVariant)}: ${parameters.join(", ")}.`;
        }
    }
}
class TemporarilyUnavailable {
    constructor() {
        this.type = "TemporarilyUnavailable";
        this.level = "danger";
        this.message = translate(t._core_types_sites.menu.creator.errors.productTemporarilyUnavailable);
    }
}
class NotDivisible {
    constructor(details) {
        this.type = "NotDivisible";
        this.level = "danger";
        this.message = `${translate(t._core_types_sites.menu.creator.errors.productNotDivisibleInThisVariant)}: ${details.join(", ")}.`;
    }
}
class OutOfOrderingHours {
    constructor(nextOrderAvailableAt, canPreorder) {
        this.type = "OutOfOrderingHours";
        this.level = "warning";
        if (nextOrderAvailableAt === null) {
            this.message = translate(t._core_types_sites.menu.alerts.restaurantIsNotTakingOrdersNow);
        }
        else if (nextOrderAvailableAt.type === "today") {
            this.message = translate(t._core_types_sites.menu.alerts.ordersWillBeProcessed.today, { hour: nextOrderAvailableAt.hour });
        }
        else if (nextOrderAvailableAt.type === "tomorrow") {
            this.message = translate(t._core_types_sites.menu.alerts.ordersWillBeProcessed.tomorrow, { hour: nextOrderAvailableAt.hour });
        }
        else {
            this.message = translate(t._core_types_sites.menu.alerts.ordersWillBeProcessed.later, { date: nextOrderAvailableAt.date });
        }
        if (canPreorder) {
            this.message = `${this.message}, ${translate(t._core_types_sites.menu.alerts.ordersWillBeProcessed.forAFutureDate)}.`;
            this.level = "info";
        }
    }
}
class ProductCartOutOfOrderingHours {
    constructor(nextOrderAvailableAt, canPreorder) {
        this.type = "OutOfOrderingHours";
        this.level = "warning";
        if (nextOrderAvailableAt === null) {
            this.message = translate(t._core_types_sites.menu.alerts.restaurantIsNotTakingOrdersNow);
        }
        else if (nextOrderAvailableAt.type === "today") {
            this.message = translate(t._core_types_sites.menu.alerts.ordersWillBeProcessed.today, { hour: nextOrderAvailableAt.hour });
        }
        else if (nextOrderAvailableAt.type === "tomorrow") {
            this.message = translate(t._core_types_sites.menu.alerts.ordersWillBeProcessed.tomorrow, { hour: nextOrderAvailableAt.hour });
        }
        else {
            this.message = translate(t._core_types_sites.menu.alerts.ordersWillBeProcessed.later, { date: nextOrderAvailableAt.date });
        }
        if (canPreorder) {
            this.message = `${this.message}, ${translate(t._core_types_sites.menu.alerts.ordersWillBeProcessed.forAFutureDate)}.`;
            this.level = "info";
        }
        else {
            this.message = `${this.message}. ${translate(t._core_types_sites.menu.alerts.ordersWillBeProcessed.onlyInRestaurant)}.`;
        }
    }
}
